export interface User {
  userID: number;
  firstName: string;
  lastName: string;
  email: string;
  userType: UserType;
  actionNeeded?: AuthActionNeeded;
}

export type UserPermissions = Partial<{
  canDoManualBooking: boolean;
  canDoBooking: boolean;
  canDoQuotes: boolean;
  canDoTracking: boolean;
  canDoReports: boolean;
  canDoMyProfile: boolean;
  canDoPinpoint: boolean;
  canDoAdmin: boolean;
  canDoMSP: boolean;
  canDoMSPAdmin: boolean;
  canDoSystemAdmin: boolean;
  canDoMarketing: boolean;
  canDoDocumentCenter: boolean;
}>;

export enum UserType {
  Admin = "Admin",
  SysAdmin = "SysAdmin",
  User = "User",
  QuikQuoteUser = "QuikQuoteUser",
}

export enum AuthActionNeeded {
  Register = "Register",
  ChangePassword = "ChangePassword",
}
